import { Empty, Entity, Loading } from "components";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Card, Image } from "semantic-ui-react";
import { api, ui } from "services";
import ImageInfo from "./image-info";
import { useSelector } from "react-redux";
import { RootState } from "reducer/store";

export default function FolderImages() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();
  const [activeImage, setActiveImage] = useState(null);
  const [openImageInfo, setOpenImageInfo] = useState(false);
  const [city, setCity] = useState<any>(null);
  const [user, setUser] = useState<any>(null);
  const [device, setDevice] = useState<any>(null);
  const query = new URLSearchParams(search);
  const date = Number(query.get("date"));
  const userInfo = useSelector((state: RootState) => state.user);

  async function loadImages() {
    try {
      setLoading(true);
      let where: any = { folder_date: date };
      if (user) {
        where.user_id = user;
      }
      if (device) {
        where.device_id = device;
      }
      if (city) {
        where.city_id = city;
      }
      let { data } = await api.post("/api/get-list-image-by-folder", {
        where,
      });
      setData(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    loadImages();
  }, []);
  async function onDelete(item: any) {
    await ui.confirm("Bạn có chắc chắn muốn xóa ảnh này không?");
    await api.post("/api/delete-image", { id: item.id });
    loadImages();
  }
  return (
    <Card fluid>
      {userInfo.role !== 2 && (
        <Card.Content>
          <div className="flex gap-2 w-full items-end flex-wrap">
            <div className="w-1/4 min-w-[200px]">
              <p>Tìm theo tài khoản:</p>
              <div className="w-full">
                <Entity
                  value={user}
                  gridName={"user"}
                  multiple={false}
                  onChange={(val: any) => {
                    setUser(val);
                  }}
                />
              </div>
            </div>
            <div className="w-1/4 min-w-[200px]">
              <p>Tìm theo thiết bị:</p>
              <div className="w-full">
                <Entity
                  value={device}
                  gridName={"devices"}
                  multiple={false}
                  onChange={(val: any) => {
                    setDevice(val);
                  }}
                />
              </div>
            </div>
            {userInfo.role === 0 && (
              <div className="w-1/4 min-w-[200px]">
                <p>Tìm theo tỉnh:</p>
                <div className="w-full">
                  <Entity
                    value={city}
                    gridName={"city"}
                    multiple={false}
                    onChange={(val: any) => {
                      setCity(val);
                    }}
                  />
                </div>
              </div>
            )}
            <Button
              icon="search"
              content="Tìm kiếm"
              color="blue"
              onClick={() => {
                loadImages();
              }}
            />
          </div>
        </Card.Content>
      )}

      <Card.Content header={`Hình ảnh trong ngày ${date}`}></Card.Content>
      <Card.Content>
        <ImageInfo
          imageInfo={activeImage}
          open={openImageInfo}
          onClose={() => {
            setOpenImageInfo(false);
          }}
        />
        {loading ? (
          <Loading />
        ) : (
          <div className="flex flex-wrap">
            {data.map((i) => (
              <div className="p-2">
                <Card>
                  <Card.Content
                    onClick={() => {
                      setOpenImageInfo(true);
                      setActiveImage(i);
                    }}
                  >
                    <Image src={i.image} />
                    <p className="mt-4">
                      Thời gian: {dayjs(i.created_at).format("HH:mm")}
                    </p>
                    <p>Đơn vị: {i.team}</p>
                  </Card.Content>
                  <Card.Content>
                    <Button
                      onClick={() => {
                        onDelete(i);
                      }}
                      content="Xóa"
                      icon="trash"
                      labelPosition="left"
                      color="red"
                    />
                  </Card.Content>
                </Card>
              </div>
            ))}
            {!data.length && <Empty />}
          </div>
        )}
      </Card.Content>
    </Card>
  );
}
